import { createSelector } from 'reselect'

import { PLAN_TYPES } from 'containers/App/constants'
import { selectActualFeatureFlags, selectActualLicenses } from 'containers/App/selectors'

const selectCampaignsLoader = (state) => state.awarenessCenter.campaigns.campaignsLoader
export const selectRecommendedCampaignsLoader = (state) =>
  state.awarenessCenter.campaigns.recommendedCampaignsLoader
const selectError = (state) => state.awarenessCenter.campaigns.error
const selectData = (state) => state.awarenessCenter.campaigns.data
const selectStatusFilter = (state) => state.awarenessCenter.campaigns.statusFilter
const selectDateFilter = (state) => state.awarenessCenter.campaigns.dateFilter
const selectMessage = (state) => state.awarenessCenter.campaigns.message
const selectLanguagesFilter = (state) => state.awarenessCenter.campaigns.languagesFilter
const selectCampaignTypeFilter = (state) => state.awarenessCenter.campaigns.campaignTypeFilter
const selectCampaignsSearchFilter = (state) => state.awarenessCenter.campaigns.search
const selectPage = (state) => state.awarenessCenter.campaigns.page
const selectSortProperty = (state) => state.awarenessCenter.campaigns.sortProperty
const selectRecommendedCampaigns = (state) => state.awarenessCenter.campaigns.recommendedCampaigns
const selectSelectionData = (state) => state.awarenessCenter.campaigns.selectionData
const selectRecommendedPreviewData = (state) =>
  state.awarenessCenter.campaigns.recommendedPreviewData
const selectMainLoader = createSelector(
  selectCampaignsLoader,
  selectRecommendedCampaignsLoader,
  (campaignsLoader, recommendedCampaignsLoader) => campaignsLoader && recommendedCampaignsLoader
)

const selectIsIneligibleAutonomousCampaignsAccount = createSelector(
  selectActualFeatureFlags,
  selectActualLicenses,
  (ff, licenses) =>
    !ff.AUTONOMOUS_CAMPAIGNS &&
    ![PLAN_TYPES.SAT_SUITE, PLAN_TYPES.COMPLETE_PROTECT].includes(licenses.plan)
)

export {
  selectError,
  selectData,
  selectStatusFilter,
  selectDateFilter,
  selectLanguagesFilter,
  selectCampaignTypeFilter,
  selectCampaignsSearchFilter,
  selectPage,
  selectMessage,
  selectSortProperty,
  selectRecommendedCampaigns,
  selectRecommendedPreviewData,
  selectMainLoader,
  selectCampaignsLoader,
  selectIsIneligibleAutonomousCampaignsAccount,
  selectSelectionData,
}
